import { useGetAssets } from "@/components/parts/assets/api";
import { useGetAgency } from "@/components/parts/master/agency/api";
import {
  useGetAlsintan,
  useGetAlsintanByCategoryId,
  useGetAlsintanCategory,
} from "@/components/parts/master/alsintan/api";
import {
  useGetPoktan,
  useGetPoktanById,
} from "@/components/parts/master/farmer-group/api";
import { useGetAgencyMember } from "@/components/parts/master/member/api";
import { useGetOwnership } from "@/components/parts/master/ownership/api";

export const usePoktanOptions = () => {
  const { data: FarmerGroup } = useGetPoktan("limit=9999");

  const farmerGroupOptions =
    FarmerGroup?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return farmerGroupOptions;
};

export const useAlsintanOptions = () => {
  const { data: Alsintan } = useGetAlsintan("limit=9999");

  const alsintanOptions =
    Alsintan?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return alsintanOptions;
};

export const useAlsintanCategoryOptions = () => {
  const { data: AlsintanCategory } = useGetAlsintanCategory("limit=9999");

  const alsintanCategoryOptions =
    AlsintanCategory?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return alsintanCategoryOptions;
};

export const useAlsintanByCategoryOptions = (id: number) => {
  const { data: Alsintan } = useGetAlsintanByCategoryId(id as number);

  const alsintanByCategoryOptions =
    Alsintan?.data.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return alsintanByCategoryOptions;
};

export const useAgencyOptions = () => {
  const { data: FarmerGroup } = useGetAgency("limit=9999");

  const agencyOptions =
    FarmerGroup?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return agencyOptions;
};

export const usePoktanMemberOptions = (id: string) => {
  const { data: FarmerGroup } = useGetPoktanById(id as string);

  const farmerMemberOptions =
    FarmerGroup?.data.members.map((item) => ({
      value: item.user.id.toString(),
      label: item.user.name,
    })) || [];

  return farmerMemberOptions;
};

export const useAgencyMemberOptions = (id: string) => {
  const { data } = useGetAgencyMember(id as string);

  const options =
    data?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    })) || [];

  return options;
};

export const useAssetOptions = () => {
  const { data: FarmerGroup } = useGetAssets();

  const assetsOptions =
    FarmerGroup?.data.items.map((item) => ({
      value: item.id.toString(),
      label: item.namaAlsintan,
    })) || [];

  return assetsOptions;
};

export function useGetOwnershipOptions() {
  const { data } = useGetOwnership("limit=1000&page=1");
  const ownershipStatus =
    data?.data.items.map((item) => ({
      label: item.name,
      value: item.id.toString(),
    })) || [];
  return ownershipStatus;
}

export const statusOptions = [
  { label: "Semua", value: "" },
  {
    label: "Diajukan",
    value: "DIAJUKAN",
  },
  {
    label: "Disetujui Admin Kecamatan",
    value: "SETUJUI_ADMIN_KECAMATAN",
  },
  {
    label: "Disetujui Penyuluh",
    value: "SETUJUI_PENYULUH",
  },
  {
    label: "Dijadwalkan",
    value: "DIJADWALKAN",
  },
  {
    label: "Disetujui Dinas",
    value: "SETUJUI_DINAS",
  },
  {
    label: "Terkirim",
    value: "TERKIRIM",
  },
  {
    label: "Selesai",
    value: "SELESAI",
  },
  {
    label: "Terlambat",
    value: "TERLAMBAT",
  },
];

export const submissionCategoryOptions = [
  { label: "Semua", value: "" },
  {
    label: "Pinjam Pakai",
    value: "PinjamPakai",
  },
  {
    label: "Hibah",
    value: "Hibah",
  },
];

// export const usePlantOptions = () => {
//   const { data: Alsintan } = useGetPlant("limit=99");

//   const alsintanOptions =
//     Alsintan?.data.items.map((item) => ({
//       value: item.id.toString(),
//       label: item.name,
//     })) || [];

//   return alsintanOptions;
// };

// export const usePupukOptions = (query?: string) => {
//   const { data: Alsintan } = useGetPupuk(`${query}`);

//   const alsintanOptions =
//     Alsintan?.data.items.map((item) => ({
//       value: item.id.toString(),
//       label: item.name,
//     })) || [];

//   return alsintanOptions;
// };

// export const useTanahStatusOptions = () => {
//   const { data: Alsintan } = useGetTanahStatus("limit=99");

//   const alsintanOptions =
//     Alsintan?.data.items.map((item) => ({
//       value: item.id.toString(),
//       label: item.name,
//     })) || [];

//   return alsintanOptions;
// };

// export const useMetodeOptions = () => {
//   const { data: Alsintan } = useGetMetode("limit=99");

//   const alsintanOptions =
//     Alsintan?.data.items.map((item) => ({
//       value: item.id.toString(),
//       label: item.name,
//     })) || [];

//   return alsintanOptions;
// };

// // user
// export const useUserOptions = (query?: string) => {
//   const { data: Alsintan } = useGetUser(`${query}`);

//   const alsintanOptions =
//     Alsintan?.data.items.map((item) => ({
//       value: item.id.toString(),
//       label: item.name,
//     })) || [];

//   return alsintanOptions;
// };
